/* Başlık paneli (assets/hs-header-dock.css): telefonda aşağı kaydırırken çekilir, yukarı kaydırınca geri gelir.
   Menü, arama, sepet çekmecesi ya da tam ekran galeri açıkken, sayfanın en üstünde ve klavyeyle başlığa
   gelindiğinde hep görünür kalır. Küçük titreşimlerde oynamasın diye yön değişimi birikerek sayılır. */
(() => {
  if (window.__hsHeaderDock) return;
  window.__hsHeaderDock = true;

  const mq = matchMedia('(max-width: 989px)');
  const section = () => document.querySelector('.section-header');
  const busy = () =>
    document.body.classList.contains('hs-nav-open') ||
    !!document.querySelector('.section-header details[open], cart-drawer.active, .hs-lb:not([hidden]), dialog[open]');

  let away = false;
  const set = v => {
    if (v === away) return;
    away = v;
    const s = section();
    if (s) s.classList.toggle('hs-dock-away', v);
  };

  let last = scrollY, run = 0, queued = false;
  const tick = () => {
    queued = false;
    const y = scrollY, d = y - last;
    last = y;
    if (!mq.matches || y < 140 || busy()) { run = 0; set(false); return; }
    run = Math.sign(d) === Math.sign(run) ? run + d : d;
    if (run > 28) set(true);
    else if (run < -18) set(false);
  };
  addEventListener('scroll', () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(tick);
  }, { passive: true });

  /* ana sayfada fotoğraf başlığın altına çekilir; hs3-skin bunu yalnızca kapsülün boyuyla yaptığından panelin üst
     boşluğu açık renk şerit olarak kalıyordu. Çekme payı bölümün gerçek boyuyla verilir. */
  const overlay = () => {
    const s = section();
    if (!s) return;
    if (mq.matches && document.body.classList.contains('hs-hd-over')) s.style.setProperty('margin-bottom', -s.offsetHeight + 'px', 'important');
    else s.style.removeProperty('margin-bottom');
  };
  const watch = () => {
    overlay();
    const s = section();
    if (s && 'ResizeObserver' in window) new ResizeObserver(overlay).observe(s);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();

  document.addEventListener('focusin', e => { if (e.target.closest && e.target.closest('.section-header')) set(false); });
  mq.addEventListener('change', () => { set(false); overlay(); });
})();
